import { render, staticRenderFns } from "./ManageAdditionalCompetenciesModal.vue?vue&type=template&id=0d5be216&scoped=true&"
import script from "./ManageAdditionalCompetenciesModal.vue?vue&type=script&lang=js&"
export * from "./ManageAdditionalCompetenciesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5be216",
  null
  
)

export default component.exports